export const ADMIN_DATA = 'ADMIN_DATA';
export const SET_USER_RESTAURANTS = 'SET_USER_RESTAURANTS';